import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { editProveedor, saveProveedor } from "../../../../../../../../../../redux/features/currentProveedor";
import { añadirPieza, modificarPieza } from "../../../../../../../../../../redux/features/fichaPresupuesto";
import ConfirmModal from "../../../../../../../shared/components/ConfirmModal";
import ProveedorModal from "../../../../../../../shared/components/ProveedorModal";
import { PROVEEDORES_API } from "../../../../../../../shared/services/proveedores";
import EnvioModal from "./components/EnvioModal";
import PiezaModal from "./components/PiezaModal";
import PiezasSelectorDialog from "./components/PiezasSelector";
import ProveedorSelectorDialog from "./components/ProveedorSelector";
import { toast } from "react-toastify";
import ProveedorPocoFiableModal from "./components/PiezaModal/components/ProveedorPocoFiableModal";
import { checkIfHasValesProveedor } from "../../../../../../../shared/helpers/functionalities";
import InfoModal from "../../../../../../../shared/components/InfoModal";

export default function PiezasWizard({
    cliente,
    presupuestoId,
    selectedDireccionId,
    esVenta,
    isNew,
    isEdit,
    isDuplicate,
    isForDelete,
    onPiezasResult,
    onDeletePieza,
    onServicioEnvio,
    onCancel,
    openVinarosParts
}) {
    const dispatch = useDispatch();
    const [openForm, setOpenForm] = useState(false);
    const [openEnvioForm, setOpenEnvioForm] = useState(false);
    const [openProveedorForm, setOpenProveedorForm] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showPiezaSelectorModal, setShowPiezaSelectorModal] = useState(false);
    const [showProvSelectorModal, setShowProvSelectorModal] = useState(false);
    const [scrappingData, setScrappingData] = useState(null);
    const [showUnreliableModal, setShowUnreliableModal] = useState(false);
    const [showValesModal, setShowValesModal] = useState(false);
    const [currentProv, setCurrentProv] = useState(null);

    const currentProveedor = useSelector(state => {
        return state.currentProveedor
    });
    const currentPieza = useSelector(state => {
        return state.currentPieza
    });
    const tipoPiezas = useSelector((state) => {
        const { tipo_piezas } = state;
        return tipo_piezas;
    });
    const [medidas, setMedidas] = useState(null);
    const [currentTipoPieza, setCurrentTipoPieza] = useState(null);
    
    useEffect(() => {
        if (isNew || isEdit) { 
            setOpenForm(true);
            setCurrentTipoPieza(currentPieza?.tipo_pieza_id);
        } else {
            setOpenForm(false);
        }
        
        if (isDuplicate && currentPieza) { duplicarPieza(currentPieza); }

        if (isForDelete) { setShowConfirmModal(true); }
        else { setShowConfirmModal(false); }

        if (currentPieza && !currentProveedor) {
            dispatch({ type: 'proveedor/fullfilled', payload: currentPieza?.proveedor });
        }

        if (currentPieza) {
            const medidasHasValues = medidas && Object.values(medidas).some(value => value != null && value !== "");
            const medidasCurrentPieza = currentPieza.medidas ? currentPieza.medidas.split('x') : [];
            if (!medidasHasValues) {
                if(medidasCurrentPieza.length) {
                    setMedidas({
                        largo: medidasCurrentPieza[0],
                        ancho: medidasCurrentPieza[1],
                        alto: medidasCurrentPieza[2],
                        peso: currentPieza.peso,
                    });
                } else {
                    setMedidas({
                        largo: getMedidasPieza(currentPieza).largo,
                        ancho: getMedidasPieza(currentPieza).ancho,
                        alto: getMedidasPieza(currentPieza).alto,
                        peso: getMedidasPieza(currentPieza).peso,
                    });
                }
                return;
            }

            if(currentTipoPieza !== currentPieza.tipo_pieza_id) {
                setMedidas({
                    largo: getMedidasPieza(currentPieza).largo,
                    ancho: getMedidasPieza(currentPieza).ancho,
                    alto: getMedidasPieza(currentPieza).alto,
                    peso: getMedidasPieza(currentPieza).peso,
                });
                setCurrentTipoPieza(currentPieza.tipo_pieza_id);
                return;
            }
        }
    }, [isEdit, isNew, isDuplicate, isForDelete, currentPieza]);


    const getTipoPieza = (tipoPiezaId) =>
        tipoPiezas.find((tp) => tp.id === tipoPiezaId);

    const getMedidasPieza = (pieza) => {
        const tipoPieza = getTipoPieza(parseInt(pieza.tipo_pieza_id));
        return {
            largo: tipoPieza?.largo,
            ancho: tipoPieza?.ancho,
            alto: tipoPieza?.alto,
            peso: tipoPieza?.peso,
        };
    };

    const duplicarPieza = async(pieza) => {
        handleSubmitPieza({
            url: pieza.url,
            id_referencia_plataforma: pieza.id_referencia_plataforma,
            nombre: pieza.nombre,
            referencia_pieza: pieza.referencia_pieza,
            con_descuento: pieza.con_descuento,
            disponible: pieza.disponible,
            precio_original: pieza.precio_original,
            precio_compra: pieza.precio_compra,
            precio_transporte: pieza.precio_transporte,
            precio_venta: pieza.precio_venta,
            precio_tarifa: pieza.precio_tarifa,
            casco: pieza.casco,
            km_motor: pieza.km_motor,
            observaciones: pieza.observaciones,
            observaciones_desguace: pieza.observaciones_desguace,
            tipo_pieza_id: pieza.tipo_pieza_id,
            tipo_garantia_id: pieza.tipo_garantia_id,
            proveedor_id: pieza?.id ? pieza.proveedor.id : pieza.proveedor_id,
            marca_id: pieza.marca_id,
            modelo_id: pieza.modelo_id,
            descuento: pieza.descuento,
            tarifa_valor: pieza.tarifa_valor,
            tarifa_tipo: pieza.tarifa_tipo,
            integracion: pieza.integracion,
            pieza_integracion_id: pieza.pieza_integracion_id,
            reservada_ec: pieza.reservada_ec,
            confirmacion: pieza.confirmacion,
            pago_proveedor: pieza.pago_proveedor,
            integracion_json: pieza.integracion_json,
            contiene_casco: pieza.contiene_casco,
            netsuite_id: pieza.netsuite_id,
            medidas: pieza.medidas,
            peso: pieza.peso,
            servicio_envio: pieza.servicio_envio,
            unidades: pieza?.id ? pieza?.presupuesto_relationship?.unidades : pieza.unidades
        });
    }

    const deletePieza = (confirm) => {
        setShowConfirmModal(false);

        if(confirm) {
            onDeletePieza(currentPieza);
        } else onCancel();
    }

    const handleCloseForm = () => { setMedidas(null); setOpenForm(false); onCancel();}
    const handleOpenEnvioForm = (pieza) => { 
        dispatch({type: "pieza/fullfilled", payload: pieza || currentPieza});
        setOpenEnvioForm(true); 
    }
    const handleCloseEnvioForm = () => { setOpenEnvioForm(false); }

    const handleSubmitPieza = async (data) => {
        dispatch({type: 'loading/set', payload: true});

        if(presupuestoId > 0) {
            data.presupuesto_id = presupuestoId;
        }

        if(medidas) {
            data.peso = parseFloat(medidas?.peso);
            data.medidas = `${medidas?.largo}x${medidas?.ancho}x${medidas?.alto}`;
            setMedidas(null);
        }

        let part = null;
        if(currentPieza.servicio_envio) {
            if(isEdit) {
                dispatch(modificarPieza(data, presupuestoId > 0 ? presupuestoId : null))
            } else {
                part = await dispatch(añadirPieza(data, presupuestoId > 0 ? presupuestoId : null))
            };

            setOpenForm(false);
            setScrappingData(null);
            onCancel();
            onPiezasResult((!isDuplicate && !isEdit ? 'new' : 'other'));
            if(part?.partsVinaros && part?.partsVinaros?.count > 0) {
                openVinarosParts({...part.partsVinaros, oldPart: data.servicio_envio });
            }
        } else {
            toast.error('Se tiene que asignar el envio a la pieza para guardarla!');
        }
    };

    const handleServicioEnvio = (servicio) => {
        dispatch({type: "pieza/servicio_envio", payload: servicio});
        setOpenEnvioForm(false);
        onServicioEnvio();
    }

    const handleOpenPiezasSelector = (data) => {
        setScrappingData(data);
        setShowPiezaSelectorModal(true);
    }

    const handleOpenProveedorSelector = (data) => {
        setScrappingData({...data,
        pieza: data.scrapping});
        console.log(data)
        setShowProvSelectorModal(true);
    }

    const handleOpenProveedorForm = (proveedor = null) => { 
        setOpenProveedorForm(true); 
        dispatch({type: 'proveedor/fullfilled', payload: proveedor});
    }

    const associateProv = async (proveedor, newName) => {
        try {
            await PROVEEDORES_API.associate(proveedor, newName)
        } catch (e) {
            console.log(e)
        }
    }

    const handleSelectProveedor = (proveedor, isNew) => {
        const scrappingPieza = scrappingData.pieza;
        //Hacemos petiçao para asociar proveedores
        associateProv(proveedor,scrappingPieza.proveedor.nombre)
        scrappingPieza.proveedor = proveedor;
        delete scrappingPieza.proveedors;
        dispatch({type: "pieza/fullfilled", payload: scrappingPieza});
        setShowProvSelectorModal(false);
        dispatch({type: 'proveedor/fullfilled', payload: scrappingPieza.proveedor});
        handleCheckVales(scrappingPieza.proveedor);
        
        if(isNew) { setOpenProveedorForm(true); }
    }

    const setPiezaFromScrappingSelector = (pieza) => {
        const scrappingPieza = setPiezaFromScrapping(pieza, scrappingData.url);

        if (pieza.proveedors){
            dispatch({type: 'proveedor/fullfilled', payload: pieza.proveedor});
            setScrappingData({...scrappingData, pieza: {...scrappingPieza, proveedors: pieza.proveedors, proveedor: pieza.proveedor}})
            setShowProvSelectorModal(true);
        } else {
            dispatch({type: 'proveedor/fullfilled', payload: scrappingPieza.proveedor});
            dispatch({type: "pieza/fullfilled", payload: scrappingPieza});
        }
    }

    const setPiezaFromScrapping = (scrapping, scrappingURL) => {
        return {
            ...scrapping,
            url: scrappingURL,
            precio_original: scrapping.precio_original ? parseFloat(scrapping.precio_original) : scrapping.precio_original,
            precio_compra: scrapping.precio_original ? parseFloat(scrapping.precio_original) : scrapping.precio_original,
            precio_transporte: scrapping.precio_envio ? parseFloat(scrapping.precio_envio) : 0,
            casco: 0,
            marca_id: scrapping.marca_id ? scrapping.marca_id : '',
            modelo_id: scrapping.modelo_id ? scrapping.modelo_id : '',
            tipo_pieza_id: scrapping.tipo_pieza_id ? scrapping.tipo_pieza_id : '',
            km_motor: scrapping.kilometraje ? scrapping.kilometraje : '',
            observaciones: scrapping.observaciones ? scrapping.observaciones : '',
            con_descuento: true,
        }
    }

    const handleClosePiezasSelectorModal = () => setShowPiezaSelectorModal(false);
    const handleCloseProveedorModal = () => setOpenProveedorForm(false);

    const handleUpdateProveedor = () => { 
        dispatch({type: 'proveedor/fullfilled', payload: currentProveedor});
        handleCheckVales(currentProveedor)
    }

    const handleSubmitProveedor = async(data) => {
        dispatch({type: 'loading/set', payload: true});

        if(!data?.id) {
            const proveedorResponse = await PROVEEDORES_API.check({
                email: data.email,
                telefono: data.telefono,
                cif: data.cif,
            }).finally(() => dispatch({ type: "loading/set", payload: false }));

            if(!proveedorResponse.data) {
                dispatch(saveProveedor(data))
                dispatch({type: 'proveedor/fullfilled', payload: data});
                handleCheckVales(data)
            } else {
                handleCheckVales(proveedorResponse.data)
                dispatch({type: 'proveedor/fullfilled', payload: proveedorResponse.data});
                /*if(checkIfIsReliableProveedor(proveedorResponse.data)) {
                    dispatch({type: 'proveedor/fullfilled', payload: proveedorResponse.data});
                } else {
                    dispatch({type: 'proveedor/fullfilled', payload: proveedorResponse.data});
                    setShowUnreliableModal(true);
                }*/
            }
        } else {
          dispatch(editProveedor(data))
          handleUpdateProveedor();
        }
    }

    const onChangeMedidas = (key, value) => {
        setMedidas(
            {...medidas, [key]: value}
        );
    }

    const handleSetProveedor = (confirm) => {
        if(confirm) {
            handleCheckVales(currentProveedor)
            dispatch({type: 'proveedor/fullfilled', payload: currentProveedor});
        } else {
            dispatch({type: 'proveedor/fullfilled', payload: null});
            setOpenForm(false);
            onCancel();
        }

        setShowUnreliableModal(false);
    }

    const handleCheckVales = (proveedor) => {
        if(checkIfHasValesProveedor(proveedor)) {
            setCurrentProv(proveedor);
            setShowValesModal(true);
        } else handleCloseValesProveedor();
    }
    const handleCloseValesProveedor = () => { 
        setCurrentProv(null);
        setShowValesModal(false); 
    }

    return (
        <div className="w-100 d-flex flex-column justify-content-center">
            { (openForm) &&
                <PiezaModal
                    open={openForm}
                    isEdit={isEdit}
                    esVenta={esVenta}
                    onSubmitPieza={handleSubmitPieza}
                    onClose={handleCloseForm}
                    onPiezasSelector={handleOpenPiezasSelector}
                    onProveedorSelector={handleOpenProveedorSelector}
                    onOpenProveedorForm={handleOpenProveedorForm}
                    onOpenServicioEnvio={handleOpenEnvioForm}
                    onSetEnvioProveedor={onServicioEnvio}
                />
            }

            { (openProveedorForm) &&
                <ProveedorModal
                    open={openProveedorForm}
                    proveedor={currentProveedor}
                    isEdit={currentProveedor ? true : false}
                    fromPresupuesto={true}
                    onSubmitProveedor={handleSubmitProveedor}
                    onSubmitAction={handleUpdateProveedor}
                    onClose={handleCloseProveedorModal}
                />
            }

            { (openEnvioForm) &&
                <EnvioModal 
                    open={openEnvioForm}
                    selectedDireccionId={selectedDireccionId}
                    cliente={cliente}
                    pieza={currentPieza}
                    proveedor={currentProveedor}
                    medidas={medidas}
                    onChangeMedidas={onChangeMedidas}
                    onSubmit={handleServicioEnvio}
                    onClose={handleCloseEnvioForm}
                />
            }

            { (showConfirmModal) && 
                <ConfirmModal
                    onConfirmAction={deletePieza} 
                    title={'Eliminar pieza'} 
                    description={'Estás seguro de eliminar la pieza del presupuesto?'}
                    state={showConfirmModal}>
                </ConfirmModal>
            }

            { showPiezaSelectorModal && 
                <PiezasSelectorDialog
                    open={showPiezaSelectorModal}
                    data={scrappingData.scrapping}
                    onConfirmAction={setPiezaFromScrappingSelector} 
                    onClose={handleClosePiezasSelectorModal}
                />
            }
            { showProvSelectorModal && 
                <ProveedorSelectorDialog
                    open={showProvSelectorModal}
                    proveedor={scrappingData.pieza.proveedor}
                    data={scrappingData.pieza.proveedors}
                    onConfirmAction={handleSelectProveedor}
                />
            }

            { (showUnreliableModal) &&
                <ProveedorPocoFiableModal
                    pieza={currentPieza}
                    onConfirmAction={handleSetProveedor} 
                    state={showUnreliableModal}>
                </ProveedorPocoFiableModal>
            }

            { (showValesModal) && 
                <InfoModal
                    state={showValesModal}
                    title={'Aviso: ' + currentProv.nombre + ' tiene vales de descuento disponibles'}
                    content={
                        <p>{currentProv.nombre} tiene un vale de {currentProv?.vales?.find(v => v.active)?.total - currentProv?.vales?.find(v => v.active)?.gastado}€ disponible</p>
                    }
                    width={'sm'}
                    onClose={handleCloseValesProveedor}
                ></InfoModal>
            }
        </div>
    );
}